import { DateHelper } from '../helpers/date.helper';
import { DateRange } from './date-range.type';

export type ExtendedDate = Date | 'today' | 'yesterday';

export class ExtendedDateRange {
  constructor(public start: ExtendedDate, public end: ExtendedDate) { }

  static toDateRange(extendedDateRange: ExtendedDateRange): DateRange {
    if (extendedDateRange == null) {
      return null;
    }
    return new DateRange(ExtendedDateRange.toDate(extendedDateRange.start), ExtendedDateRange.toDate(extendedDateRange.end));
  }

  static fromDateRange(dateRange: DateRange): ExtendedDateRange {
    if (dateRange == null) {
      return null;
    }
    return new ExtendedDateRange(ExtendedDateRange.fromDate(dateRange.start), ExtendedDateRange.fromDate(dateRange.end));
  }

  private static fromDate(date: Date): ExtendedDate {
    return DateHelper.isToday(date) ? 'today'
      : DateHelper.isYesterday(date) ? 'yesterday'
      : date;
  }

  private static toDate(extendedDate: ExtendedDate): Date {
    if (extendedDate == null) {
      return null;
    }
    if (typeof extendedDate === 'string') {
      return ExtendedDateRange.parseQueryParam(extendedDate);
    }

    return extendedDate;
  }

  public static formatQueryParam(date: Date): string {
    return DateHelper.isToday(date) ? 'today'
      : DateHelper.isYesterday(date) ? 'yesterday'
      : DateHelper.formatApiDateOnly(date);
  }

  public static parseQueryParam(param: string): Date {
    return param === 'today' ? DateHelper.startOfToday()
      : param === 'yesterday' ? DateHelper.startOfYesterday()
      : DateHelper.parseApiDate(param);
  }
}
